import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { exportTableElementAsCsv } from '../../../services/allo-table-csv';

export interface AlloTableDialogData {
  tableHtml: string;
  title: string;
  columnCount: number;
  /** dialog-loader.module stubs MatDialogRef with {}, so the opener passes close. */
  close: () => void;
}

@Component({
  selector: 'qt-ai-chat-table-dialog',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="qt-table-dialog">
      <div class="qt-table-dialog__bar">
        <div class="qt-table-dialog__heading">
          @if (data.title) {
            <h2 class="qt-table-dialog__title">{{ data.title }}</h2>
          }
          <span class="qt-table-dialog__count">
            {{ data.columnCount }} columns
          </span>
        </div>
        <div class="qt-table-dialog__actions">
          <button
            type="button"
            class="qt-table-dialog__export"
            (click)="exportCsv()">
            <mat-icon aria-hidden="true">download</mat-icon>
            <span>Download CSV</span>
          </button>
          <button
            type="button"
            class="qt-table-dialog__close"
            aria-label="Close"
            (click)="close()">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </div>
      </div>
      <div class="qt-table-dialog__body" #body [innerHTML]="safeTable"></div>
    </div>
  `,
  styleUrl: './ai-chat-table-dialog.component.scss',
})
export class AiChatTableDialogComponent {
  readonly data = inject<AlloTableDialogData>(MAT_DIALOG_DATA);
  private readonly body = viewChild<ElementRef<HTMLElement>>('body');

  readonly safeTable = this.data.tableHtml;

  close(): void {
    this.data.close();
  }

  exportCsv(): void {
    const table = this.body()?.nativeElement.querySelector('table');
    if (table) {
      exportTableElementAsCsv(table);
    }
  }
}
